import { Component } from '@angular/core';
import { ITableColumnConfig, ITableHeaderConfig } from 'src/app/components/tablecomponent/tablecomponent.constants';
import { CadinverterComponent } from 'src/app/modals/cadinverter/cadinverter.component';
import { InverterModel } from 'src/app/models/invertermodel';
import { ModalService } from 'src/app/services/modalservice/modalservice.service';
import { InverterRepository } from 'src/app/services/repository/inverterrepository';
import { ArrayInterfaceToArrayClass } from 'src/app/services/uteis/arraytoarrayclass';

@Component({
  selector: 'app-inverters',
  templateUrl: './inverters.component.html',
  styleUrls: ['./inverters.component.scss']
})
export class InvertersComponent {
  public loading: boolean = false;
  public list: InverterModel[] = [];

  /**
   * Configurações de table
   */
  public configTable: ITableColumnConfig[] = [
    {
      key: 'idInversora',
      label: 'ID',
      size: '100px',
      columnsize: 7.5,
      alignment: 'center',
    },
    {
      key: 'idMaquina',
      label: 'ID Máquina',
      size: '100px',
      columnsize: 7.5,
      alignment: 'center',
    },
    { key: 'Marca', label: 'Marca', size: '1fr', columnsize: 40 },
    { key: 'Modelo', label: 'Modelo', size: '1fr', columnsize: 40 },
    { key: 'NumeroSerial', label: 'Serial', size: '1fr', columnsize: 40 },
    { key: 'EnderecoModbus', label: 'Endereço ModBus', size: '1fr', columnsize: 40 },
  ];

  public TableHeaderConfig: ITableHeaderConfig = {
    background: 'var(--color-toptable)',
    color: 'var(--color-toptable-contrast)',
  };

  constructor(private repository: InverterRepository, private modal: ModalService) {}

  ngOnInit(): void {
    this.init();
  }

  public async init() {
    this.loading = true;
    try {
      this.list = ArrayInterfaceToArrayClass(
        await this.repository.getAll(),
        InverterModel
      );
      console.log('[INFO] Listagem de inversoras => ', this.list);
    } catch (error) {
      console.log('[ERROR] Init => ', error);
    }
    this.loading = false;
  }

  public async new(data: InverterModel = new InverterModel()) {
    try {
      this.modal
        .show(CadinverterComponent, {
          height: 'auto',
          width: '566px',
          data: data,
        })
        .then((_) => {
          this.init();
        });
    } catch (error) {}
  }
}
